export default __webpack_public_path__ + "static/media/thumb4.8eba9e3e.png";